import { PULSE_VIEW_ID, trackPulseView } from './pulseViewIds';

export type CheckoutPaymentModalKind = 'credit' | 'gift';

/**
 * Checkout credit / gift card modal view_id from Add vs Edit entry point.
 */
export const resolveCheckoutPaymentModalViewId = ({
  kind,
  isEdit,
}: {
  kind: CheckoutPaymentModalKind;
  isEdit: boolean;
}): string => {
  if (kind === 'credit') {
    return isEdit
      ? PULSE_VIEW_ID.EDIT_CREDIT_CARD_MODAL
      : PULSE_VIEW_ID.ADD_CREDIT_CARD_MODAL;
  }
  return isEdit
    ? PULSE_VIEW_ID.EDIT_GIFT_CARD_MODAL
    : PULSE_VIEW_ID.ADD_GIFT_CARD_MODAL;
};

export function trackCheckoutPaymentModalView(params: {
  kind: CheckoutPaymentModalKind;
  isEdit: boolean;
  pagePath?: string;
}): void {
  trackPulseView(
    resolveCheckoutPaymentModalViewId({
      kind: params.kind,
      isEdit: params.isEdit,
    }),
    { page_path: params.pagePath ?? window.location.pathname }
  );
}
